import { Environment } from './Environment.ts';

export type EntitiesConfiguration = {
  header: string;
  footer: string;
  maintenanceBanner: string;
  modal: string;
};

export type Configuration = {
  space: string;
  accessToken: string;
  environment: Environment;
};

export const DEFAULT_SPACE_ID = 'wuwte8ad21cy';

export const DEFAULT_ENTITIES: EntitiesConfiguration = {
  header: 'Avios.com Header',
  footer: 'Avios.com Footer',
  maintenanceBanner: 'Avios.com Maintenance Banner',
  modal: 'Avios.com modal',
};
